import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPagePortrait: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlankPagePortrait"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H12.1429C14.8857 22 17.4686 20.7086 19.1143 18.5143C19.6892 17.7477 20 16.8154 20 15.8571V2H4ZM18 15.5V4H6V19.9989C8.33553 19.962 10.5675 19.0183 12.2218 17.364L13.8726 15.7132L14.5547 16.1679C15.0668 16.5093 16.05 16.7257 16.8887 16.5777C17.2912 16.5067 17.5716 16.3665 17.7388 16.2067C17.8824 16.0695 18 15.8668 18 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlankPagePortrait;
